<template>
  <div id="app">
    <div class="component-wrapper">
    <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
}
</script>
<style>
@import "./assets/styles/main-v138_vue.css";
@import url("https://cdn.jsdelivr.net/npm/animate.css@3.5.1");
</style>
